export const uuidLoad = async () => {
  if (!window.uuid) {
    const { v5 } = await import(/* webpackChunkName: "uuidLib"*/ 'uuid')
    window.uuid = { v5 }
  }
}
